import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ViewService } from '../../view.service';
import { ViewToolsMode } from '../../models/view-tools-mode.enum';
import { trigger, transition, style, animate } from '@angular/animations';
import { ViewActions } from '../../state/view.actions';
import { ViewBreakpoint } from '../../models/view-breakpoint.enum';
import { ViewLayout } from '../../models/view-layout.enum';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-view-toolbar',
  templateUrl: './view-toolbar.component.html',
  styleUrls: ['./view-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ 
          opacity: 0,
          transform: 'translateY(200px)'
        }),
        animate('300ms ease-in-out', style({ 
          opacity: 1,
          transform: '*'
        }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ 
          transform: 'translateY(200px)',
          opacity: 0 
        }))
      ])
    ])
  ]
})
export class ViewToolbarComponent implements OnInit {
  // ---------- Child Elements ----------
  @ViewChild('viewToolbar', {static: false }) viewToolbar: ElementRef;
  
  
  // ---------- Observables ----------
  @Select(ViewState.getBreakpoint)
  breakpoint$: Observable<ViewBreakpoint>;



  // ---------- Input / Output ----------
  @Input()
  canExit = true;

  @Input()
  mode = ViewToolsMode.Main;

  @Input()
  lockMode = false;

  
  // ---------- Class Variables ----------
  ngUnsubscribe = new Subject();
  viewBreakpoint = ViewBreakpoint;
  viewToolsMode = ViewToolsMode;
  viewLayout = ViewLayout;



  // ---------- Lifecycle hooks ----------
  constructor(
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef,
    private layoutService: LayoutService
  ) { }

  ngOnInit() {
    this.initLayoutListener();
  }

  initLayoutListener() {
    this.store.select(ViewState.getLayout)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        if (this.lockMode) {
          return;
        }

        this.mode = ViewToolsMode.Main;

        if (this.layoutService.isLayoutVisible(ViewLayout.Media)) {
          this.mode = ViewToolsMode.Media;
        }

        if (this.layoutService.isToolsVisible()) {
          this.mode = ViewToolsMode.Tools;
        }

        this.changeDetectorRef.markForCheck();
      });
  }



  // ---------- Interactions ----------
  handleExitClick() {
    const layout = this.store.selectSnapshot(ViewState.getLayout);
    layout.media.status = ViewLayoutStatus.Hide;
    layout.tools.status = ViewLayoutStatus.Hide;
    this.store.dispatch(new ViewActions.SetLayout(layout));
  }
}
